module.exports = __webpack_public_path__ + "img/oracle.386671e6.svg";